module.exports = __webpack_public_path__ + "static/pillBanner-fffad4e629c2475fd80414e873551eef.png";